import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react';
import Helmet from 'react-helmet';
import { Query } from '../types/graphql-types';

interface ISeo {
  description?: string;
  lang?: string;
  meta?: Array<{ name: string; content: string }>;
  keywords?: string[];
  title: string;
}

export const SEO = ({
  description,
  lang = 'en',
  meta = [],
  keywords = [],
  title
}: ISeo) => {
  const data: Query = useStaticQuery(graphql`
    query {
      contentfulCompanyInfo(node_locale: { eq: "en-US" }) {
        shortName
      }
    }
  `);

  const company = data.contentfulCompanyInfo!;

  return (
    <Helmet
      htmlAttributes={{ lang }}
      title={title}
      titleTemplate={`%s | ${company.shortName as string}`}
      meta={[
        {
          content: description,
          name: `description`
        },
        {
          content: title,
          property: `og:title`
        },
        {
          content: description,
          property: `og:description`
        },
        {
          content: `website`,
          property: `og:type`
        },
        {
          content: `summary`,
          name: `twitter:card`
        },
        {
          content: title,
          name: `twitter:title`
        },
        {
          content: description,
          name: `twitter:description`
        }
      ]
        .concat(
          keywords.length > 0
            ? {
                content: keywords.join(`, `),
                name: `keywords`
              }
            : []
        )
        .concat(meta)}
    />
  );
};
